import _ from "underscore";

import Persistence from "pages/common/lib/grabyo-persistence";
import Constants from "const/constants";

import SocialCredential from "./base";

const YouTubeCredential = SocialCredential.extend({
    initialize: function () {
        YouTubeCredential.__super__.initialize.apply(this, arguments);
        if (this.isMonetizationEnabled()) {
            this.loadPersistedSettings();
        }

        _.bindAll(this, `fetchPolicies`, `fetchContentOwners`);
    },

    parse: function (response) {
        response = YouTubeCredential.__super__.parse.apply(this, arguments);

        response.name = response.googleTitle;
        response.profileImage = response.googleProfileImageUrl;

        response.typeLabel = `YouTube`;
        response.platformType = `YouTube Channel`;

        return response;
    },

    toJSON: function () {
        const json = YouTubeCredential.__super__.toJSON.apply(this, arguments);
        json.monetizationEnabled = this.isMonetizationEnabled();

        return json;
    },

    onShareSuccessful: function (response) {
        return YouTubeCredential.__super__.onShareSuccessful.call(
            this,
            `shareViaYoutubeCount`,
            response
        );
    },

    isMonetizationEnabled: function () {
        // Did the user authorized Content ID API for this Channel?
        return this.get(`contentIdApiEnabled`) === `true`;
    },

    isMonetizationActive: function () {
        // Is Content ID API currently active for this Channel?
        return this.get(`monetizationActive`) === true;
    },

    getMonetizationShareInfo: function () {
        if (
            !this.get(`monetizationActive`) ||
            this.get(`youtubeContentOwnerId`) ===
                Constants.YOUTUBE_MONETIZATION.NONE
        ) {
            return {};
        }

        return {
            youtubePolicyId: this.get(`youtubePolicyId`),
            youtubeContentOwnerId: this.get(`youtubeContentOwnerId`)
        };
    },

    fetchPolicies: function (contentOwnerId) {
        return $.get(
            `ws/youtubetools/users/${this.get(`userId`)}/socialcreds/${this.get(
                `socialId`
            )}/contentowners/${contentOwnerId}/policies`
        );
    },

    fetchContentOwners: function () {
        return $.get(
            `ws/youtubetools/users/${this.get(`userId`)}/socialcreds/${this.get(
                `socialId`
            )}/contentowners`
        );
    },

    disableContentIdApi: function () {
        return $.ajax({
            url: `ws/youtubetools/users/${this.get(
                `userId`
            )}/socialcreds/${this.get(`socialId`)}/contentowners`,
            type: `DELETE`
        }).done((response) => {
            this.set(this.parse(response));
        });
    },

    share: function (shareId, data) {
        data = _.extend(data, this.getMonetizationShareInfo());
        return YouTubeCredential.__super__.share.call(this, shareId, data);
    },

    persistData: function () {
        const monetizationActive =
            this.get(`youtubeMonetizationFlag`) ===
            Constants.YOUTUBE_MONETIZATION.CONTENT_ID;
        this.set({ monetizationActive });

        const id = this.get(`socialId`);
        const socialCred = {
            id,
            monetizationActive,
            youtubePolicyId: this.get(`youtubePolicyId`),
            youtubeContentOwnerId: this.get(`youtubeContentOwnerId`)
        };

        const persistedCred = Persistence.PermStore.get(
            `socialCredential:${id}`
        );
        const data = persistedCred
            ? _.extend(persistedCred, socialCred)
            : socialCred;

        Persistence.PermStore.set(`socialCredential:${id}`, data);
    }
});

export default YouTubeCredential;
